import { useQuery } from '@apollo/client/react';

import { notNullOrUndefined } from '#cutils/misc/notNullOrUndefined';
import { TrackEventDataType } from '#types/tracking';

import { ArticleItemResultsItem } from '../ArticleItemResultsItem';
import { MoreButton } from '../base/MoreButton/MoreButton';

import styles from './AuthorArticlesResultsTable.module.scss';
import { AuthorFetchMoreDocument, AuthorDocument } from './__generated__/Author.generated';

type Props = {
	authorName: string | null;
	isPreviewRequest: boolean;
	authorGuid: string;
};

export function AuthorArticlesResultsTable({ authorName, authorGuid, isPreviewRequest }: Props) {
	const { data, error, fetchMore } = useQuery(AuthorDocument, {
		variables: { authorGuid, count: 10, withCacheTag: false },
		ssr: !isPreviewRequest,
		fetchPolicy: 'cache-first',
		nextFetchPolicy: 'network-only',
	});

	if (error) {
		throw new Error(`No data returned from 'AuthorContainerQuery': '${authorGuid}'`);
	}

	const { authorArticles } = data ?? { authorArticles: undefined };

	const mappedauthorArticles =
		authorArticles?.edges
			?.filter(notNullOrUndefined)
			.map(({ node }) => node)
			.filter(notNullOrUndefined)
			.map((article) => {
				return <ArticleItemResultsItem article={article} key={article.rowId} trackEventDataType={TrackEventDataType.AuthorArticleClick} />;
			}) ?? [];

	const articlesText = authorArticles?.totalCount === 1 ? 'Beitrag' : 'Beiträge';

	return (
		<section className={styles.wrapper}>
			<span className={styles.title}>
				<h3>Alle Inhalte von {authorName ?? ''}</h3>
				<span className={styles.articleCount}>
					{authorArticles?.totalCount} {articlesText}
				</span>
			</span>

			{mappedauthorArticles}

			{!!authorArticles?.pageInfo.hasNextPage && (
				<MoreButton
					className={styles.moreButton}
					onClick={() => {
						fetchMore({
							query: AuthorFetchMoreDocument,
							variables: {
								authorGuid,
								count: 10,
								cursor: authorArticles?.pageInfo.endCursor,
							},
						});
					}}
					count={typeof authorArticles?.totalCount === 'number' ? authorArticles.totalCount - mappedauthorArticles.length : undefined}
				>
					Mehr laden
				</MoreButton>
			)}
		</section>
	);
}
